import React, { Fragment, Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import arrowDown from '../../images/arrow-down-black.svg';
// import './generalFaq.css';
import './faq.css';
import tempSchedule from '../../images/tempPaymentSchedule.png';
import uberChanges1 from '../../images/uberChanges3.png';
import uberChanges2 from '../../images/uberChanges1.png';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import Button from '../../artzu-ui/src/Button';

class PaymentFaq extends Component {
  render() {
    const { status, email, history } = this.props;
    const faq_content = [
      {
        title: 'What are the changes being made?',
        text: (
          <Fragment>
            <p>
              Starting March 4-6, 2020, you will receive your earnings
              directly from Uber.
            </p>
            <p>
              You will have the option to receive weekly payouts directly
              into your bank account - or - daily payouts with the Daily
              Pay option from Uber | Payfare.
            </p>
            <p>
              To add your bank account details on your Uber Driver account:{' '}
              <b>
                {' '}
                open the Uber Driver App → tap your profile picture → tap
                Account → tap Payment → and add payout method
              </b>
            </p>
          </Fragment>
        )
      },
      {
        title: 'Why are these changes being made?',
        text: (
          <Fragment>
            <p>This will benefit you in two ways.</p>
            <p>
              {' '}
              Firstly, this will eventually allow you to drive on any
              ridesharing company (using Autzu vehicles), and secondly
              allows for direct weekly or daily payouts for your trips for
              Uber or Lyft.
            </p>
          </Fragment>
        )
      },
      {
        title: 'How will I pay for the Autzu rental fees?',
        text: (
          <Fragment>
            <p>
              As your earnings will come directly from Uber, your Autzu
              rental fees will now be charged to your credit or debit card
              at the end of your booking.
            </p>
            <p>
              As always, continue to book in advance with no upfront
              charge. Your card on file will be charged at the end of your
              booking.
            </p>
            <p>
              <a href="/profile">Click here</a> and then click the{' '}
              <b>Payment Methods</b> tab to add your credit or debit card
              details to your Autzu account.
            </p>
            <p>
              Any last minute cancellations, late fees, gas shortages, or
              damage related charges will be charged to your card on file.
            </p>
          </Fragment>
        )
      },
      {
        title: 'What are the steps that I need to take?',
        text: (
          <Fragment>
            <div className={'faq__changes--container'}>
              <div className={'faq__changes--column'}>
                <p>
                  As your earnings will come directly from Uber, your Autzu
                  rental fees will now be charged to your credit or debit
                  card at the end of your booking.
                </p>
                <p>
                  <b>Step 1:</b> Click the button{' '}
                  <b>Add Payment Method:</b>{' '}
                </p>
                <p>
                  <a href="https://www.autzu.com/profile">
                    <Button
                      className={'faq__changes--button'}
                      primary
                      fullWidth
                      label={'Add Payment Method'}
                    />
                  </a>
                </p>
                <p>
                  {' '}
                  <img
                    className={'faq__changes--img'}
                    src={uberChanges1}
                  />
                </p>
                <p>
                  To add a payment method at any time,{' '}
                  <b>
                    open the Autzu App → tap the menu icon in top left of
                    screen → tap View Profile → tap Payment Method → tap
                    Add Card
                  </b>
                </p>
              </div>
              <div className={'faq__changes--column'}>
                <p>
                  You will also need to log-in to your Uber Driver account
                  through the Autzu app or website so that we can add the
                  Autzu vehicles to your Uber profile.
                </p>
                <p>
                  <b>Step 2:</b> Click the button{' '}
                  <b>Verify Uber Account</b>{' '}
                </p>
                <p>
                  <a href="https://www.autzu.com/connect">
                    <Button
                      className={'faq__changes--button'}
                      primary
                      fullWidth
                      label={'Verify Uber Account'}
                    />
                  </a>
                </p>
                <p>
                  {' '}
                  <img
                    className={'faq__changes--img'}
                    src={uberChanges2}
                  />
                </p>
                <p>
                  Once you have completed this step,{' '}
                  <b>
                    a member of the Autzu team will contact you to confirm
                    cars have been successfully added.
                  </b>
                </p>
              </div>
            </div>
          </Fragment>
        )
      },
      {
        title: 'What if I do not have a credit card?',
        text: (
          <p>
            Our system accepts all major debit and credit cards. This
            includes any type of card payment (Visa, Visa Debit,
            Mastercard, Mastercard Debit, Maestro, and American Express).
          </p>
        )
      },
      {
        title: 'How will Autzu add cars to my Uber Driver account?',
        text: (
          <Fragment>
            <p>
              You will need to log-in to your Uber Driver account through
              the Autzu app or website so that we can add the Autzu
              vehicles to your Uber profile. Click the button above to{' '}
              <b>Verify Uber Account.</b>
            </p>
            <p>
              Once you have completed this step, a member of the Autzu team
              will contact you to confirm cars have been successfully
              added.
            </p>
            <p>
              This process includes the upload of all Autzu vehicle related
              documents such as vehicle registration, insurance and the
              safety inspection certificate.
            </p>
          </Fragment>
        )
      },
      {
        title: 'What happens to any outstanding payouts?',
        text: (
          <Fragment>
            <p>
              <b>Prior to March 6, 2020:</b> Your earnings from trips made
              prior to March 6 will continue to be sent to Autzu, and
              forwarded to you as per the existing payment schedule.
            </p>
            <p>
              <b>After March 6, 2020:</b> Your earnings from trips made
              after March 6 will be sent to you by Uber directly into your
              bank account.
            </p>
          </Fragment>
        )
      },
      {
        title:
          'What if I have an outstanding payout from a previous week (Feb 24-Mar 2 for example):',
        text: (
          <Fragment>
            <p>
              If you were sent an email on March 3rd about outstanding
              payouts, the technical issue has yet to be resolved. There is
              a technical issue with the software that connects the Uber
              and Autzu systems to calculate and display your earnings.
              This connection stopped working on Feb 18, 2020 and therefore
              has resulted in an inability to process an accurate payout
              for these pay periods:
            </p>
            <br />
            <p>Feb 10, 2020 - Feb 17, 2020</p>
            <p>Feb 17, 2020 - Feb 24, 2020</p>
            <p>Feb 24, 2020 - Mar 02, 2020</p>
            <p>Mar 02, 2020 - Mar 09, 2020</p>
            <p>
              We are in direct communication with Uber to resolve this
              technical issue to process your outstanding payouts.
            </p>
            <p>
              We regret this inconvenience, and will update you as soon as
              we have clarity on this issue and a resolution date.
            </p>
          </Fragment>
        )
      },
      {
        title: 'Further questions? ',
        text: (
          <p>
            Please call us at 1-833-692-8898 or email us at
            drivers@autzu.com
          </p>
        )
      }
    ];
    return (
      <Fragment>
        <Helmet>
          <title>Changes FAQ | Autzu</title>
          <meta
            name="description"
            content="Get all the answers to your frequently asked questions about our Uber Changes."
          />
        </Helmet>
        <section className="container">
          <div className="newFaq">
            <Header
              persistentTitle
              title="Important Autzu Changes starting March 4-6, 2020"
              back
              onClick={() => {
                history.goBack();
              }}
            />
            {/* <div className="general-faq-header">
                <h2 className="general-faq-header--size">Payment FAQ</h2>
              </div> */}
            <div className="newFaq__body container">
              <div className="newFaq__container">
                <div className="newFaq__sidebar">
                  <SideBarContent status={status} signedIn={email} />
                </div>
                <div className="newFaq__content--container">
                  <div className="payment-faq__blurb--">
                    <div className="">
                      <div id="generalAccordion1">
                        <div
                          id="general1"
                          className="panel-collapse collapse in">
                          <div
                            className="panel-body"
                            style={{ padding: '0px' }}>
                            <div
                              className="panel-group"
                              id="generalAccordion2">
                              {faq_content.map((content, index) => (
                                <div
                                  key={`payment-faq-item${index}`}
                                  className="mini-faq__panel">
                                  <div
                                    className="mini-faq__heading collapsed"
                                    data-toggle="collapse"
                                    href={`#paymentFaq${index + 1}`}>
                                    <h4 className="mini-faq__panel--title">
                                      {content.title}{' '}
                                    </h4>
                                    {/* <img className="mini-faq__arrow" src={arrowDown} alt="arrow" /> */}
                                  </div>
                                  <div
                                    id={`paymentFaq${index + 1}`}
                                    className="panel-collapse">
                                    <div className="mini-faq__panel--body">
                                      {content.text}
                                      {content.image ? (
                                        <img
                                          className="banner__schedule--image"
                                          alt="schedule"
                                          src={tempSchedule}
                                          style={{
                                            display: 'block',
                                            width: '90%',
                                            margin: 'auto'
                                          }}
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}
export default withRouter(PaymentFaq);



// WEBPACK FOOTER //
// ./src/components/Static/ChangesFaq.js